<template>
  <div>
    <div class="loader centrado" v-if="loading">
      <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
    </div>
    <template v-if="series.length > 0">
      <apexchart
        type="line"
        height="300"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </template>
    <template v-else>
      <h4>
        No se encuentra la información para visualizar esta grafica, por favor
        comuniquese con el administrador del sistema.
      </h4>
    </template>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import VueApexCharts from "vue-apexcharts";
import Datepicker from "vuejs-datepicker";
Vue.component("apexchart", VueApexCharts);
export default {
  name: "BarChart",
  data: () => {
    return {
      anio: null,
      mes: null,
      loading: true,
      series: [
        {
          data: [],
        },
        {
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          height: 300,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
      },
    };
  },
  props: {
    grafica: null,
  },
  components: {
    Datepicker,
  },
  computed: {
    ...mapGetters({ alturas: "alturaMora/alturas" }),
  },
  methods: {
    datosGrafica(values) {
      if (values !== null || values !== undefined) {
        var datos = this.alturas;

        let x = [];
        this.series = [];
        this.series.push({
          name: "Porcentaje",
          data: [],
        });

        datos.forEach((element) => {
          x.push(element.rango_inicial + " - " + element.rango_final);
          this.series[this.series.length - 1].data.push(element.porcentaje);
        });

        this.chartOptions = {
          ...this.chartOptions,
          ...{
            xaxis: {
              categories: x,
            },
            yaxis: {
              labels: {
                formatter: function (value) {
                  return value.toLocaleString("es-CO");
                },
              },
            },
          },
        };
      } else {
        this.series = [];
      }

      this.loading = false;
    },
    fixDate(event) {
      return this.$moment(event).format("YYYY");
    },
  },
  watch: {
    alturas(newVal) {
      this.datosGrafica(newVal);
    },
  },
  mounted() {
    this.datosGrafica();
  },
};
</script>
<style>
.centrado {
  display: flex;
  justify-content: center; /* center horizontally */
  align-items: center;
}
</style>